var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{staticClass:"app-logo",attrs:{"name":"logo-header","width":null,"height":null}})
}
var staticRenderFns = []

export { render, staticRenderFns }